import { Box } from "@mui/material";
import { StoryAvatar } from "Components/Stories/StoryAvatar";
import { Resources, useResource } from "Translations/Resources";

/**
 * The bar's empty state: a single grayed-out Mo.one circle shown when no story groups are live,
 * so the stories panel keeps its place on the dashboard instead of disappearing. Purely
 * decorative — brand stories will reappear here once published.
 */
export const MooneStoryPlaceholder = () => {
  const { t } = useResource();

  return (
    // Disabled placeholder: dimmed and without onClick (StoryAvatar then renders a
    // non-interactive element, so it is skipped by keyboard/screen-reader focus too).
    <Box sx={{ opacity: 0.45 }}>
      <StoryAvatar
        name={t(Resources.Common.AppName)}
        authorKind="moone"
        ringVariant="none"
      />
    </Box>
  );
};
